import { createSlice } from '@reduxjs/toolkit';
import { createExamination, getExaminationDetails, getExaminations, updateExamination } from '.';

const initialState = {
	loading: false,
	examinations: [],
	examinationsDetails: null,
	total: 0,
};

const examinations = createSlice({
	name: 'examinations',
	initialState,
	reducers: {
		resetExaminations: () => initialState,
		setExaminationsDetails: (state, action) => {
			state.examinationsDetails = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(getExaminations.pending, (state) => {
				state.loading = true;
			})
			.addCase(getExaminations.fulfilled, (state, action) => {
				state.loading = false;
				const { total, data } = action.payload.response.data.data;
				state.examinations = data;
				state.total = total;
			})
			.addCase(getExaminations.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(createExamination.pending, (state) => {
				state.loading = true;
			})
			.addCase(createExamination.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(createExamination.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(updateExamination.pending, (state) => {
				state.loading = true;
			})
			.addCase(updateExamination.fulfilled, (state) => {
				state.loading = false;
				state.examinationsDetails = null;
			})
			.addCase(updateExamination.rejected, (state) => {
				state.loading = false;
			});

		builder
			.addCase(getExaminationDetails.pending, (state) => {
				state.loading = true;
			})
			.addCase(getExaminationDetails.fulfilled, (state, action) => {
				state.loading = false;
				state.examinationsDetails = action.payload.response.data.data;
			})
			.addCase(getExaminationDetails.rejected, (state) => {
				state.loading = false;
			});
	}
});

export const { resetExaminations, setExaminationsDetails } = examinations.actions;

export default examinations.reducer;